import { Scene } from 'scrollmagic'
import { BREAKPOINTS } from '/javascripts/constants/breakpoints'
import bus from '/javascripts/bus'
import UI from '/javascripts/utils/UI'
import scrollController from '/javascripts/utils/scrollController'

UI({
  component: '.js-videoSlider'
}, ({ component }) => {
  const state = { scene: null }

  check()
  bus.on('windowResize', check)

  function check() {
    destroy()

    if (window.matchMedia(`(min-width: ${BREAKPOINTS.LAPTOP}px)`).matches) {
      create()
    }
  }

  function create() {
    state.scene = new Scene({
      triggerElement: component,
      triggerHook: 75 / window.innerHeight,
      duration: component.clientHeight
    })

    state.scene.addTo(scrollController)
      .on('enter', _ => bus.emit('updateSiteHeader', { isLight: true }))
      .on('leave', _ => bus.emit('updateSiteHeader', { isLight: false }))
  }

  function destroy() {
    state.scene && state.scene.destroy()
  }
})
